import React, { Component, Fragment } from 'react';
import { Dialog, TableHead, DialogTitle, DialogContent, Typography, IconButton, Grid, Divider, Table, TableBody, TableRow, TableCell, Box, Tooltip, Tabs, Tab, ListItemText, ListItemSecondaryAction, ListItem, List, ListItemIcon } from '@mui/material';
import { AddCircle, AddCircleOutline, ArrowBack, ArrowCircleLeft, ArrowCircleLeftOutlined, ArrowCircleRight, ArrowCircleRightOutlined, CheckCircleRounded, ExpandLess, ExpandMore, FileCopyRounded } from '@mui/icons-material';

import { extension } from 'mime-types'
import Currency from '../../../common/Currency';

export const SIDES = [
    {title:"Face Avant", name:"front"}, 
    {title:"Face Arrière", name:"back"}, 
    {title:"Gauche", name:"left"}, 
    {title:"Droite", name:"right"},
    {title:"Haut", name:"top"}, 
    {title:"Bas", name:"bottom"}, 
]
class EquipementDetails extends Component {
    state = { 
        photos: [],
        openRemarkList: false
    }
    // getLastPictures = () => {
    //     const { equipement } = this.props
    //     let from = "equipement_photo"
    //     if (loanExist) {
    //         photosFrom = "loan_photo"

    //     }
    //     let photos = SIDES.map(side => `${from}_${side.name}`)
    // }    
    displayTags = (tags) => {
        const { IMMO_TAGS } = this.props;
        
        return tags.split(', ').map(tag => IMMO_TAGS && IMMO_TAGS[tag] && `#${IMMO_TAGS[tag].immo_tag_name}`).join(" ")
    }
    getRemarksList = () => {
        const { loans, EMPLOYEES, USERS, EQUIP } = this.props;
        console.log('====================================');
        console.log("LOAN LIST : ",{loans});
        console.log('====================================');
        let history = []
        loans && history.push(loans.filter(loan => !loan.loan_status.startsWith("RESA")).map( loan => 
            <>
                { loan.is_over &&  
                    <ListItem >
                        <ListItemIcon>
                            <ArrowCircleLeftOutlined color="success"/>
                        </ListItemIcon>
                        <ListItemText 
                            primary={
                                <Typography variant="body1">
                                    {loan.equipement_remarks_end}
                                </Typography>
                            } 
                            secondary={
                                `${USERS[loan.loan_user].username} ${USERS[loan.loan_user].lastname}`
                            }
                        />
                        <ListItemSecondaryAction>
                            <ListItemText secondary={
                                <Typography color="primary">
                                    {new Date(loan.loan_end_date).toLocaleDateString("fr-FR")}
                                </Typography>
                            } />
                        </ListItemSecondaryAction>
                    </ListItem>
                }
                <ListItem 
                    // button 
                    // onClick={ () => this.props.handleSingle(loan.loan_id)}
                >
                    <ListItemIcon>
                        <ArrowCircleRightOutlined color="warning"/>
                    </ListItemIcon>
                    <ListItemText 
                        primary={
                            <Typography variant="body1">
                                {loan.equipement_remarks_start}
                            </Typography>
                        } 
                        secondary={
                            `${USERS[loan.loan_user].username} ${USERS[loan.loan_user].lastname}`
                        }
                    />
                    <ListItemSecondaryAction>
                        <ListItemText secondary={
                            <Typography color="primary">
                                {new Date(loan.loan_start_date).toLocaleDateString("fr-FR")}
                            </Typography>
                        } />
                    </ListItemSecondaryAction>
                </ListItem>
            </>
        ))
        history.push(
            <ListItem >
                <ListItemIcon>
                    <AddCircleOutline color="info" />
                </ListItemIcon>
                <ListItemText 
                    
                    primary={
                        <Typography variant="body1">
                            {EQUIP.equipement_remarks}
                        </Typography>
                    } 
                    secondary={"MISE EN SERVICE"}
                />
                <ListItemSecondaryAction>
                    <ListItemText secondary={
                        <Typography color="primary">
                            {new Date(EQUIP.equipement_date_service).toLocaleDateString("fr-FR")}
                        </Typography>
                    } />
                </ListItemSecondaryAction>
            </ListItem>
        )
        return history
    }

    render() {
        const { EQUIP, CATEGORIES, LOCALISATIONS } = this.props
        const { openRemarkList } = this.state;
        // let shade = category && category.category_color.slice(1, 2);
        // let textColor = "black"
        // if (shade) {
        //     if (!isNaN(shade)) {
        //         textColor = "white"
        //     }
        // }
        let locCHILD = LOCALISATIONS.CHILD[EQUIP.equipement_localisation] ? LOCALISATIONS.CHILD[EQUIP.equipement_localisation] : {}
        let locPARENT = LOCALISATIONS.PARENT[locCHILD.loc_parent] ? LOCALISATIONS.PARENT[locCHILD.loc_parent] : {}
        console.log('====================================');
        console.log({EQUIP, locCHILD, locPARENT}, CATEGORIES.CHILD[EQUIP.equipement_category]);
        console.log('====================================');
        
        return (
            
            <Box>
                <Grid container spacing={2} style={{marginTop: "20px"}}>
                    {/* <Grid item xs={12}>
                        <Box style={{ textAlign: 'right'}}>
                            <Tooltip title="Copier l'ID Equipement" placement="left">
                                <IconButton
                                    onClick={() => {
                                        navigator.clipboard.writeText(EQUIP.equipement_id); 
                                        this.setState({ copied : true })
                                    }}
                                    color="secondary"
                                    size="large">
                                    {this.state.copied ? <CheckCircleRounded /> : <FileCopyRounded />}
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Grid> */}
                    <Grid container item xs={12} sm={4} style={{height: "100%"}}>
                        {SIDES.map( side => 
                        // <Grid container item xs={12}>
                            <Grid 
                                key={EQUIP[`equipement_photo_${side.name}`].filename} 
                                item 
                                xs={6} 
                                style={{
                                    position: "relative", 
                                    width:"200px", 
                                    height:"200px", 
                                    overflow:"hidden"
                                }}
                            >
                                {EQUIP[`equipement_photo_${side.name}`].filetype === "application/pdf" ?
                                    <a href={`/photos/single/${EQUIP[`equipement_photo_${side.name}`].filename}`} 
                                        download={`${side.name}.${ extension(EQUIP[`equipement_photo_${side.name}`].filetype) || "pdf"}`}
                                    >
                                        <embed 
                                            src={`/photos/single/${EQUIP[`equipement_photo_${side.name}`].filename}`} 
                                            width="100%" 
                                            height="200px" 
                                            title={side.name} 
                                            type="application/pdf"
                                        />
                                    </a>
                                    :
                                    <a href={`/photos/single/${EQUIP[`equipement_photo_${side.name}`].filename}`} 
                                        download={`${side.name}.${ extension(EQUIP[`equipement_photo_${side.name}`].filetype) || "jpeg"}`}
                                    >
                                        <img 
                                            // style={{opacity: ".7"}}
                                            // style={{height: "200px"}}
                                            src={`/photos/single/${EQUIP[`equipement_photo_${side.name}`].filename}`} 
                                            title={side.name} 
                                            alt={side.name} 
                                            className="img-miniature"
                                        />
                                    </a>
                                }
                            </Grid>
                        )}
                        
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Table className="table">
                            <TableBody>
                                <TableRow>
                                    <TableCell> 
                                        <Typography variant="body1">Acquisition</Typography>
                                    </TableCell>
                                    <TableCell style={{ fontWeight: "bold"}}>{new Date(EQUIP.equipement_date_acquisition).toLocaleDateString("fr-FR")}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell> 
                                        <Typography variant="body1">Mise en service</Typography>
                                    </TableCell>
                                    <TableCell style={{ fontWeight: "bold"}}>{new Date(EQUIP.equipement_date_service).toLocaleDateString("fr-FR")}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell> 
                                        <Typography variant="body1">Catégorie:</Typography></TableCell>
                                    <TableCell style={{ fontWeight: "bold"}}>{CATEGORIES.CHILD[EQUIP.equipement_category].category_name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell> 
                                        <Typography variant="body1">Référence:</Typography></TableCell>
                                    <TableCell style={{ fontWeight: "bold"}}>{EQUIP.equipement_ref}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell> 
                                        <Typography variant="body1">Valeur Brute:</Typography></TableCell>
                                    <TableCell style={{ fontWeight: "bold"}}><Currency value={EQUIP.equipement_brut_amount} /></TableCell>
                                </TableRow>
                                {EQUIP.equipement_type === "vehicule" &&
                                <>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="body1">Immatriculation:</Typography></TableCell>
                                        <TableCell style={{ fontWeight: "bold"}}>{EQUIP.car_matricule}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="body1">Kilométrage Acquisition | Actuel:</Typography></TableCell>
                                        <TableCell style={{ fontWeight: "bold"}}>{EQUIP.car_km_start}km | {EQUIP.car_km_current}km</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="body1">Carburant Actuel:</Typography></TableCell>
                                        <TableCell style={{ fontWeight: "bold"}}>{EQUIP.car_fuel_current}%</TableCell>
                                    </TableRow>
                                </>
                                }
                                <TableRow>
                                    <TableCell> 
                                        <Typography variant="body1">Description:</Typography></TableCell>
                                    <TableCell style={{ fontWeight: "bold"}}>{EQUIP.equipement_desc}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell> 
                                        <Typography variant="body1">Localisation:</Typography></TableCell>
                                        <TableCell style={{ fontWeight: "bold"}}><i>{locPARENT.loc_name}</i> - {locCHILD.loc_name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell> 
                                        <Typography variant="body1">Mot Clés:</Typography></TableCell>
                                        <TableCell style={{ fontWeight: "bold", color:"darkcyan"}}>
                                            {EQUIP.equipement_tags && this.displayTags(EQUIP.equipement_tags)}
                                        </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                                    {/* TO DO add button history remarks */}
                        <List>
                            <ListItem>
                                <ListItemText primary={"Dernières remarques"} secondary={EQUIP.equipement_remarks_current} />
                                <IconButton
                                    // style={{color: textColor}}
                                    onClick={ () => this.setState({
                                        openRemarkList: !openRemarkList
                                    }) }
                                    size="large">
                                {openRemarkList ? <ExpandLess /> : <ExpandMore />}

                                </IconButton>
                            </ListItem>
                            {openRemarkList &&
                                this.getRemarksList()
                            }
                        </List>
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

export default EquipementDetails;